import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { StorageSystemManufacturersActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.StorageSystemManufacturer };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    StorageSystemManufacturersActions.CreateStorageSystemManufacturer,
    StorageSystemManufacturersActions.ReadStorageSystemManufacturer,
    StorageSystemManufacturersActions.ReadStorageSystemManufacturers,
    StorageSystemManufacturersActions.UpdateStorageSystemManufacturer,
    StorageSystemManufacturersActions.DeleteStorageSystemManufacturer,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    StorageSystemManufacturersActions.ReadStorageSystemManufacturerSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    StorageSystemManufacturersActions.ReadStorageSystemManufacturersSuccess,
    (state, { response }) => {
      const items = response['hydra:member'];
      const entities = items.reduce(
        (
          entities: {
            [iri: string]: fromModuleModels.StorageSystemManufacturer;
          },
          item
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    StorageSystemManufacturersActions.CreateStorageSystemManufacturerSuccess,
    StorageSystemManufacturersActions.UpdateStorageSystemManufacturerSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    StorageSystemManufacturersActions.DeleteStorageSystemManufacturerSuccess,
    (state, { iri }) => {
      const { [iri]: removedItem, ...entities }: any = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    StorageSystemManufacturersActions.CreateStorageSystemManufacturerFail,
    StorageSystemManufacturersActions.ReadStorageSystemManufacturerFail,
    StorageSystemManufacturersActions.ReadStorageSystemManufacturersFail,
    StorageSystemManufacturersActions.UpdateStorageSystemManufacturerFail,
    StorageSystemManufacturersActions.DeleteStorageSystemManufacturerFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
